import { ActionDialog } from '@/common/dialog/ActionDialog';
import { useDialog } from '../dialog/DialogContext';
import { TitleButton } from './TitleButton';

export const ActionButton = ({ data, toolTip, icon, disabled }) => {
  const { openDialog } = useDialog();

  const openActionDialog = () => {
    openDialog(ActionDialog, { data });
  };

  return <TitleButton icon={icon} toolTip={toolTip} onClick={openActionDialog} disabled={disabled} />;
};
